export default "__VITE_ASSET__DPZcN0Wc__"